const stats = [
  { value: "35", label: "已更新话数" },
  { value: "4", label: "收录单行本卷" },
  { value: "连载", label: "当前状态" },
  { value: "免费", label: "浏览费用" },
];

export default function Hero() {
  return (
    <section id="top" className="relative overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://bainwo.github.io/api/search-image?query=warm%20and%20cozy%20anime%20cityscape%20at%20dusk%20with%20soft%20peach%20and%20cream%20gradient%20sky%2C%20small%20apartment%20buildings%20with%20glowing%20windows%2C%20stylized%20manga%20background%20art%2C%20gentle%20film%20grain%2C%20soothing%20pastel%20tone%2C%20high%20quality%20illustration&width=1600&height=900&seq=hero-bg-2026&orientation=landscape"
          alt="泡在我家的辣妹 黄昏下的公寓街景背景"
          className="h-full w-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-background-950/70 via-background-950/40 to-background-950/20" />
        <div className="absolute inset-0 bg-gradient-to-t from-background-50 via-transparent to-transparent" />
      </div>

      <div className="relative mx-auto flex max-w-7xl flex-col gap-10 px-4 pb-20 pt-28 md:px-6 md:pb-28 md:pt-36 lg:flex-row lg:items-center">
        <div className="w-full flex-1 lg:max-w-xl">
          <span className="inline-flex items-center gap-2 rounded-full bg-primary-500/90 px-3 py-1 text-xs text-background-50">
            <i className="ri-flashlight-fill text-sm" />
            连载追更中 · 已更新至第35话
          </span>
          <h1 className="font-heading mt-5 text-4xl leading-tight text-background-50 md:text-5xl">
            泡在我家的辣妹
          </h1>
          <p className="mt-4 text-base leading-relaxed text-background-100 md:text-lg">
            最新话更新进度、漫画全集与汉化资源都在这里。追更泡在我家的辣妹不用到处找，完结没有、漫画下载入口，点开即可直达最新内容。
          </p>

          <div className="mt-8 flex flex-col gap-3 sm:flex-row sm:items-center">
            <a
              href="#chapters"
              className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-6 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
            >
              <i className="ri-play-circle-fill text-base" />
              阅读最新话
            </a>
            <a
              href="#catalog"
              className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md bg-background-50/10 px-6 py-3 text-sm font-medium text-background-50 ring-1 ring-background-50/40 transition-colors hover:bg-background-50/20"
            >
              <i className="ri-book-2-line text-base" />
              查看全集目录
            </a>
          </div>

          <dl className="mt-10 grid grid-cols-4 gap-3">
            {stats.map((s) => (
              <div
                key={s.label}
                className="rounded-lg bg-background-50/10 px-2 py-3 text-center ring-1 ring-background-50/20"
              >
                <dt className="text-xs text-background-200">{s.label}</dt>
                <dd className="font-heading mt-1 text-xl text-background-50 md:text-2xl">
                  {s.value}
                </dd>
              </div>
            ))}
          </dl>
        </div>

        <div className="relative mx-auto w-full max-w-[300px] shrink-0 lg:max-w-[340px]">
          <div className="absolute -inset-3 -z-10 rounded-[2rem] bg-gradient-to-br from-accent-400/50 to-primary-400/40 blur-2xl" />
          <div className="overflow-hidden rounded-[1.25rem] ring-4 ring-background-50/30">
            <img
              src="https://bainwo.github.io/api/search-image?query=anime%20manga%20book%20cover%20of%20a%20stylish%20gyaru%20girl%20with%20long%20wavy%20brown%20hair%20sitting%20casually%20in%20a%20cozy%20warm%20room%2C%20holding%20a%20cup%2C%20peach%20and%20cream%20color%20palette%2C%20soft%20sunlight%20from%20window%2C%20romantic%20youth%20manga%20cover%20style%2C%20vibrant%20and%20detailed%2C%20high%20quality&width=680&height=960&seq=hero-cover-2026&orientation=portrait"
              alt="《泡在我家的辣妹》漫画封面"
              className="h-full w-full object-cover object-top"
            />
          </div>
          <div className="mt-3 flex items-center justify-center gap-2 text-xs text-background-100">
            <i className="ri-heart-fill text-accent-300" />
            评分与追更读者持续增长中
          </div>
        </div>
      </div>
    </section>
  );
}